import { render } from "./AdministrationModal.vue?vue&type=template&id=55f91ba0"
import script from "./AdministrationModal.vue?vue&type=script&lang=js"
export * from "./AdministrationModal.vue?vue&type=script&lang=js"

import "./AdministrationModal.vue?vue&type=style&index=0&id=55f91ba0&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__